import React from "react";
import ButtonRed from "../ButtonRed/ButtonRed";
import FloatingLogoAndButton from "../FloatingLogoAndButton/FloatingLogoAndButton";
import ReservationForm from "../ReservationForm/ReservationForm";

export default function ReservationMenu() {
  return (
    <>
      <FloatingLogoAndButton />
      <div className="bg-black text-white flex justify-center items-center py-12 min-h-[calc(100vh_-_112px)]">
        <div className="flex flex-col items-center justify-center gap-4 md:mt-20">
          <h3 className="font-bold text-xl text-center">REZERWACJE</h3>
          <ReservationForm />
        </div>
        {/* <ButtonRed
        text={"Toruń"}
        type={"outputLink"}
        url={"https://zjedz.my/whitebull-steakhouse"}
      />
      <ButtonRed
        text={"Bydgoszcz"}
        type={"outputLink"}
        url={"https://zjedz.my/whitebull-steakhouse"}
      /> */}
      </div>
    </>
  );
}
